var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLgAssignment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 61 30",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-lg-assignment_svg__clip0_2600_63435)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.25,
    y: 1,
    width: 21.75,
    height: 14,
    rx: 1,
    fill: "#A8FFF8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 15,
    height: 4,
    rx: 1,
    fill: "#CBFF88"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 10,
    height: 4,
    rx: 1,
    fill: "#CBFF88"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M19 14h15v12H19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.565 17.585c.176 0 .335.11.402.279a.464.464 0 01-.094.491l-5.314 5.513a.424.424 0 01-.474.098.452.452 0 01-.269-.417v-5.513c0-.249.195-.45.435-.45h5.314zm-4.88 4.875l3.83-3.973h-3.83v3.973zM37.028 7.968a1.39 1.39 0 000-1.913l-.729-.757a1.271 1.271 0 00-1.844 0l-1.652 1.713 2.574 2.67 1.651-1.713zm-1.344 2.67a.424.424 0 01-.614 0L31.88 7.33a.463.463 0 010-.638l1.959-2.031a2.119 2.119 0 013.074 0l.729.756c.849.88.849 2.308 0 3.189l-1.959 2.032z",
    fill: "#14454C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.684 10c.17.176.17.462 0 .638l-6.377 6.615a.432.432 0 01-.2.118l-4.25 1.12a.425.425 0 01-.415-.117.464.464 0 01-.115-.43l1.062-4.427a.455.455 0 01.115-.21l6.377-6.615a.424.424 0 01.615 0L35.684 10zm-9.48 3.856l-.858 3.574 3.431-.903 5.985-6.208-2.574-2.67-5.983 6.207z",
    fill: "#14454C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.875 5.458c.24 0 .434.202.434.45 0 .25-.194.452-.434.452H19.87v16.738H33.25c.24 0 .435.202.435.45 0 .25-.195.452-.435.452H19.435a.443.443 0 01-.435-.451V5.909c0-.25.195-.451.435-.451h7.44zM38.13 18.036v-4.41c0-.249.195-.45.435-.45s.435.201.435.45v4.41c0 .25-.195.451-.435.451a.443.443 0 01-.435-.45z",
    fill: "#14454C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 6l.99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99L50.5 6zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566L59 17zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99L9.5 21zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566L2 16z",
    fill: "#14D1C2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-lg-assignment_svg__clip0_2600_63435"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15)",
    d: "M0 0h30v30H0z"
  })))));
}
export default __webpack_public_path__ + "fonts/ai-lg-assignment-f7373220a0ad66718c5b603b2914d12c.svg";
export { SvgAiLgAssignment as ReactComponent };